import { AnimalInfo } from "../AnimalDataCalls/GQLCalls/getAnimalCall";

export interface EsfSectionsInfo {
  section_id: number;
  system_id: number;
  name: string;
  panelSectionType: number;
  section_locations: EsfLocation[]
  components?: string[];
}

export interface EsfLocation {
  name: string,
  location_id: number;
  animals: AnimalInfo[]; // TODO, flytte til section? 
}

export const TestData: EsfSectionsInfo[] = [
  {
    section_id: 1,
    system_id: 1,
    name: "first section",
    panelSectionType: 1,
    section_locations: [
      {
        name: "400",
        location_id: 1,
        animals: []
      },
      {
        name: "401",
        location_id: 2,
        animals: []
      }
      ,
      {
        name: "402",
        location_id: 3,
        animals: []
      }
      ,
      {
        name: "403",
        location_id: 4,
        animals: []
      }
    ],
    components: [
      "Duroc Gestation",
      "Duroc Gestation Plus",
    ]
  },
  {
    section_id: 2,
    system_id: 1,
    name: "second section",
    panelSectionType: 1,
    section_locations: [
      {
        name: "404",
        location_id: 5,
        animals: []
      },
      {
        name: "405",
        location_id: 6,
        animals: []
      }
    ]
  },
]